import { css } from 'styled-components'
import { theme } from '@upsolve/ui';

const LinkCSS = css`
  text-decoration: none;
  &, &:visited, &:active {
    color: ${theme.colors.brand['500']};
  }
  &:hover {
    color: ${theme.colors.brand['700']};
    text-decoration: none;
  }
`;

export default LinkCSS
